import Hls from 'hls.js';

export function cldHlsUrl(videoUrl) {
  if (!videoUrl || !videoUrl.includes('res.cloudinary.com')) return null;
  const match = videoUrl.match(/\/upload\/q_auto(:best)?,f_auto\//);
  if (!match) return null;
  // Only videos uploaded under the newer q_auto:best profile have an sp_full_hd rendition
  // eagerly generated. Older (q_auto) videos only have sp_auto ready -- routing them through
  // sp_full_hd triggers a blocking on-the-fly Cloudinary transform that can hang or 423.
  const profile = match[1] === ':best' ? 'sp_full_hd' : 'sp_auto';
  return videoUrl.replace(/\/upload\/q_auto(:best)?,f_auto\//, `/upload/${profile}/`).replace(/\.mp4$/, '.m3u8');
}

// Attaches adaptive HLS for Cloudinary videos with progressive mp4 fallback.
export function attachVideoSource(el, videoUrl) {
  const hlsUrl = cldHlsUrl(videoUrl);
  if (!hlsUrl) {
    el.src = videoUrl;
    return () => {};
  }

  let fellBack = false;
  const fallbackToMp4 = () => {
    if (fellBack) return;
    fellBack = true;
    clearTimeout(watchdog);
    el.src = videoUrl;
    el.play().catch(() => {});
  };
  // If HLS hasn't produced any playable data within this window (e.g. Cloudinary hangs or
  // 423s on a not-yet-generated rendition), fall back instead of leaving playback frozen.
  const watchdog = setTimeout(fallbackToMp4, 8000);
  el.addEventListener('loadeddata', () => clearTimeout(watchdog), { once: true });

  if (el.canPlayType('application/vnd.apple.mpegurl')) {
    el.src = hlsUrl;
    el.onerror = () => { el.onerror = null; fallbackToMp4(); };
    return () => { el.onerror = null; clearTimeout(watchdog); };
  }
  if (
    Hls.isSupported() &&
    window.MediaSource &&
    window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E"')
  ) {
    const hls = new Hls({ maxBufferLength: 12 });
    hls.loadSource(hlsUrl);
    hls.attachMedia(el);
    hls.on(Hls.Events.ERROR, (_evt, data) => {
      if (data?.fatal) {
        hls.destroy();
        fallbackToMp4();
      }
    });
    return () => { hls.destroy(); clearTimeout(watchdog); };
  }
  clearTimeout(watchdog);
  el.src = videoUrl;
  return () => {};
}
